import type { PublicSettings } from '../models/public-settings';
import { apiGet } from './api-client';

/**
 * Reads the company details the public site shows. This is the anonymous allow-list route, never
 * the staff settings endpoint — the two are separate on the server precisely so a client cannot
 * reach a private setting by passing a parameter.
 */
export async function getPublicSettings(signal?: AbortSignal): Promise<PublicSettings> {
    return apiGet<PublicSettings>('/public/settings', { signal });
}
